// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DiagnosticCode } from "./diagnostic-code";
import { EventKey, EventKeyT } from "./event-key";
import { Key, KeyT } from "./key";
import { Severity } from "./severity";
import { SourceFile } from "./source-file";

export class Diagnostic implements flatbuffers.IUnpackableObject<DiagnosticT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Diagnostic {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDiagnostic(bb: flatbuffers.ByteBuffer, obj?: Diagnostic): Diagnostic {
    return (obj || new Diagnostic()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsDiagnostic(bb: flatbuffers.ByteBuffer, obj?: Diagnostic): Diagnostic {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Diagnostic()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  code(): DiagnosticCode {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : DiagnosticCode.Unspecified;
  }

  severity(): Severity {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Severity.Error;
  }

  source(): SourceFile {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SourceFile.None;
  }

  includeIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  line(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  column(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  byteOffset(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  length(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  message(): string;
  message(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  message(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  key(obj?: Key): Key | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? (obj || new Key()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  eventKey(obj?: EventKey): EventKey | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? (obj || new EventKey()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  relatedLine(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startDiagnostic(builder: flatbuffers.Builder) {
    builder.startObject(12);
  }

  static addCode(builder: flatbuffers.Builder, code: DiagnosticCode) {
    builder.addFieldInt16(0, code, DiagnosticCode.Unspecified);
  }

  static addSeverity(builder: flatbuffers.Builder, severity: Severity) {
    builder.addFieldInt8(1, severity, Severity.Error);
  }

  static addSource(builder: flatbuffers.Builder, source: SourceFile) {
    builder.addFieldInt8(2, source, SourceFile.None);
  }

  static addIncludeIndex(builder: flatbuffers.Builder, includeIndex: number) {
    builder.addFieldInt16(3, includeIndex, 0);
  }

  static addLine(builder: flatbuffers.Builder, line: number) {
    builder.addFieldInt32(4, line, 0);
  }

  static addColumn(builder: flatbuffers.Builder, column: number) {
    builder.addFieldInt32(5, column, 0);
  }

  static addByteOffset(builder: flatbuffers.Builder, byteOffset: number) {
    builder.addFieldInt32(6, byteOffset, 0);
  }

  static addLength(builder: flatbuffers.Builder, length: number) {
    builder.addFieldInt32(7, length, 0);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, messageOffset, 0);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(9, keyOffset, 0);
  }

  static addEventKey(builder: flatbuffers.Builder, eventKeyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(10, eventKeyOffset, 0);
  }

  static addRelatedLine(builder: flatbuffers.Builder, relatedLine: number) {
    builder.addFieldInt32(11, relatedLine, 0);
  }

  static endDiagnostic(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 20); // message
    return offset;
  }

  unpack(): DiagnosticT {
    return new DiagnosticT(
      this.code(),
      this.severity(),
      this.source(),
      this.includeIndex(),
      this.line(),
      this.column(),
      this.byteOffset(),
      this.length(),
      this.message(),
      this.key() !== null ? this.key()!.unpack() : null,
      this.eventKey() !== null ? this.eventKey()!.unpack() : null,
      this.relatedLine(),
    );
  }

  unpackTo(_o: DiagnosticT): void {
    _o.code = this.code();
    _o.severity = this.severity();
    _o.source = this.source();
    _o.includeIndex = this.includeIndex();
    _o.line = this.line();
    _o.column = this.column();
    _o.byteOffset = this.byteOffset();
    _o.length = this.length();
    _o.message = this.message();
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.eventKey = this.eventKey() !== null ? this.eventKey()!.unpack() : null;
    _o.relatedLine = this.relatedLine();
  }

  unpackFields(...fields: string[]): DiagnosticT {
    const t = new DiagnosticT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("code")) {
      t.code = this.code();
    }
    if (fieldSet.has("severity")) {
      t.severity = this.severity();
    }
    if (fieldSet.has("source")) {
      t.source = this.source();
    }
    if (fieldSet.has("include_index")) {
      t.includeIndex = this.includeIndex();
    }
    if (fieldSet.has("line")) {
      t.line = this.line();
    }
    if (fieldSet.has("column")) {
      t.column = this.column();
    }
    if (fieldSet.has("byte_offset")) {
      t.byteOffset = this.byteOffset();
    }
    if (fieldSet.has("length")) {
      t.length = this.length();
    }
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("event_key")) {
      t.eventKey = this.eventKey() !== null ? this.eventKey()!.unpack() : null;
    }
    if (fieldSet.has("related_line")) {
      t.relatedLine = this.relatedLine();
    }
    return t;
  }
}

export class DiagnosticT implements flatbuffers.IGeneratedObject {
  constructor(
    public code: DiagnosticCode = DiagnosticCode.Unspecified,
    public severity: Severity = Severity.Error,
    public source: SourceFile = SourceFile.None,
    public includeIndex: number = 0,
    public line: number = 0,
    public column: number = 0,
    public byteOffset: number = 0,
    public length: number = 0,
    public message: string | Uint8Array | null = null,
    public key: KeyT | null = null,
    public eventKey: EventKeyT | null = null,
    public relatedLine: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = this.message !== null ? builder.createString(this.message!) : 0;

    Diagnostic.startDiagnostic(builder);
    Diagnostic.addCode(builder, this.code);
    Diagnostic.addSeverity(builder, this.severity);
    Diagnostic.addSource(builder, this.source);
    Diagnostic.addIncludeIndex(builder, this.includeIndex);
    Diagnostic.addLine(builder, this.line);
    Diagnostic.addColumn(builder, this.column);
    Diagnostic.addByteOffset(builder, this.byteOffset);
    Diagnostic.addLength(builder, this.length);
    Diagnostic.addMessage(builder, message);
    Diagnostic.addKey(builder, this.key !== null ? this.key!.pack(builder) : 0);
    Diagnostic.addEventKey(builder, this.eventKey !== null ? this.eventKey!.pack(builder) : 0);
    Diagnostic.addRelatedLine(builder, this.relatedLine);

    return Diagnostic.endDiagnostic(builder);
  }

  clone(): DiagnosticT {
    const obj = new DiagnosticT();
    obj.code = this.code;
    obj.severity = this.severity;
    obj.source = this.source;
    obj.includeIndex = this.includeIndex;
    obj.line = this.line;
    obj.column = this.column;
    obj.byteOffset = this.byteOffset;
    obj.length = this.length;
    obj.message = this.message;
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.eventKey = this.eventKey !== null ? this.eventKey!.clone() : null;
    obj.relatedLine = this.relatedLine;
    return obj;
  }

  equals(other: DiagnosticT): boolean {
    if (this.code !== other.code) return false;
    if (this.severity !== other.severity) return false;
    if (this.source !== other.source) return false;
    if (this.includeIndex !== other.includeIndex) return false;
    if (this.line !== other.line) return false;
    if (this.column !== other.column) return false;
    if (this.byteOffset !== other.byteOffset) return false;
    if (this.length !== other.length) return false;
    if (this.message !== other.message) return false;
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.eventKey !== null && other.eventKey !== null) {
      if (!this.eventKey!.equals(other.eventKey!)) return false;
    } else if (this.eventKey !== other.eventKey) return false;
    if (this.relatedLine !== other.relatedLine) return false;
    return true;
  }
}

export function verifyDiagnostic(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 2);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 20, "message");
    verifier.checkScalarField(tablePos, 22, 12);
    verifier.checkScalarField(tablePos, 24, 8);
    verifier.checkScalarField(tablePos, 26, 4);
  } finally {
    verifier.popDepth();
  }
}
